import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { concat, Observable, of } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import { AppState } from '../../reducers';
import * as auth from './auth.actions';
import { selectAuthUser } from './auth.selectors';
import { AuthService } from '../auth/auth.service';
import { AuthFacadeService } from 'ngpd-merceros-authentication-fe-components/core';
// import {
//   AuthenticateMFAMethodFail,
//   LoadMFASystemInfo,
//   LoadMFAUserInfo,
//   MfaActionTypes,
//   MfaAuthSuccessDone
// } from 'ngpd-merceros-mfa-fe-components';
import { CONFIG } from '../../../config';
import { LoginResponse } from './auth.models';
import { environment } from '../../../environments/environment';
// import { AddErrorToastAction, AddSuccessToastAction } from '../toaster/toaster.actions';
import { ClearStateAction } from '../../global/actions';
import { EmptyResponse } from '../../global/interfaces';
import { LoadNotificationResponse } from '../administration/notifications/notification.model';
import { User } from '../administration/user/user.models';
import { isNullOrUndefined } from 'util';
import { ToastService } from '../../shared/toaster_/toaster_.service';
import { Actions as ActionsCDK } from "atlas-cdk";
declare let pendo: any;

@Injectable()
export class AuthEffects {
  public env = environment;
  // @Effect()
  // public loginSuccess$ = this.actions$.pipe(
  //   ofType<auth.LoginSuccessAction>(auth.ActionTypes.LOGIN_SUCCESS),
  //   map(action => action.payload),
  //   switchMap(payload => {
  //     /** This will check user through MFA. Make sure to only request user info from BE when MFA is verified. */
  //     if (this.env.mfaEnabled && !payload.hasOwnProperty('user')) {
  //       // return from([new LoadMFAUserInfo((window as any)['encode_deviceprint']()), new LoadMFASystemInfo()]);

  //       return from([new AuthFacadeService]);
  //     }

  //     /** Bypass MFA and MSSO */
  //     if (this.env.mfaEnabled && payload.hasOwnProperty('user')) {
  //       this.router.navigate(['/overview']);
  //       return from([new auth.GetUserSuccessAction(payload.user)]) as any;
  //     }

  //     return from([new AuthFacadeService.MfaAuthSuccessDone()]);
  //   })
  // );

  // @Effect()
  // public mfaFailed$ = this.actions$.pipe(
  //   ofType<AuthenticateMFAMethodFail>(MfaActionTypes.AUTHENTICATE_METHOD_FAIL),
  //   switchMap(() => {
  //     return [new AddErrorToastAction('Incorrect Verification Code')];
  //   })
  // );

  public termsAccepted$ = createEffect(() => this.actions$.pipe(
    ofType<auth.AcceptTermsAndConditionsAction>(auth.ActionTypes.ACCEPT_TERMS_AND_CONDITIONS),
    switchMap(() =>
      this.acceptTerms().pipe(
        map(() =>
          new auth.AcceptTermsAndConditionsSuccessAction()
        )
      )
    )
  ));

  getUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType<auth.GetUserAction>(auth.ActionTypes.GET_USER),
    switchMap(() =>
      this.getUser().pipe(
        map((response: User) => {
          const user = this.mergeUserClaimsFromToken(response);
          const hasAcceptedTerms = !!response?.settings?.optIns?.terms;
          if (!hasAcceptedTerms) {
            this.router.navigate(['/provision/terms-and-conditions']);
          } else {
            this._authService.fullyAuthenticated$.subscribe(authenticated => {
              if (!authenticated) {
                this.router.navigate(['/overview']);
              }
            });
          }
          if (environment.pendoEnabled && hasAcceptedTerms) {
            this.initializePendo(response);
          }
          return new auth.GetUserSuccessAction(user);
        }),
        catchError(error => from([new auth.GetUserFailedAction(error)]))
      )
    )
  ));

  public termsAcceptedSuccess$ = createEffect(() => this.actions$.pipe(
    ofType<auth.AcceptTermsAndConditionsSuccessAction>(auth.ActionTypes.ACCEPT_TERMS_AND_CONDITIONS_SUCCESS),
    withLatestFrom(this.store.pipe(select(selectAuthUser))),
    tap(([, user]) => {
      if (environment.pendoEnabled) {
        this.initializePendo(user);
      }
      this.router.navigate(['/overview']);
    })
  ), { dispatch: false });

  public refreshToken$ = createEffect(() => this.actions$.pipe(
    ofType<auth.RefreshTokenAction>(auth.ActionTypes.REFRESH_TOKEN),
    switchMap(() =>
      this.refreshToken().pipe(
        map((response: LoginResponse) => new auth.RefreshTokenSuccessAction(response)),
        catchError(error => from([new auth.RefreshTokenFailedAction(error)]))
      )
    )
  ));

  public logLogout$ = createEffect(() => this.actions$.pipe(
    ofType<auth.LogLogoutAction>(auth.ActionTypes.LOG_LOGOUT),
    switchMap(() =>
      this.logOut().pipe(
        map(() =>
          new auth.LogLogoutsuccessAction({ token: null, expiresIn: -1, user: null })
        )
      )
    )
  ));

  public logout$ = createEffect(() => this.actions$.pipe(
    ofType<auth.LogoutAction>(auth.ActionTypes.LOGOUT),
    map(action => action.payload),
    tap(payload => {
      if (!!payload && payload.error) {
        this.router.navigate(['/provision/login']);
      } else {
        this.router.navigate(['/provision/login'], { queryParams: { reason: 'USER_LOGGED_OUT' } });
      }
      setTimeout(() => {
        if (!!payload && payload.error) {
          // this.store.dispatch(new AddErrorToastAction(payload.message || '', payload.title));
          this._toasterService.launchAlertError(payload.title, ActionsCDK.error, payload.message);
        } else {
          // this.store.dispatch(new AddSuccessToastAction(
          //   'We recommend that you close your browser window to protect your personal information.',
          //   'You have now logged out.'
          // ));
          this._toasterService.launchAlertSuccess('You have now logged out.', 'We recommend that you close your browser window to protect your personal information.', ActionsCDK.success);
        }
      });

    }),
    switchMap(() => [new ClearStateAction()])
  ));

  /**
   * load User Notifications
   */
  public loadUserNotification$ = createEffect(() => this.actions$.pipe(
    ofType<auth.LoadUserNotificationsAction>(auth.ActionTypes.LOAD_USER_NOTIFICATIONS),
    switchMap(() =>
      this.loadUserNotification().pipe(
        map((response: LoadNotificationResponse) =>
          new auth.LoadUserNotificationsSuccessAction(response)
        ),
        catchError(error =>
          //    from([
          //   new AddErrorToastAction(!isNullOrUndefined(error.error)
          //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message),
          //   new auth.LoadUserNotificationsFailedAction(error)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
          //   return of(new auth.LoadUserNotificationsFailedAction(error));
          // }
          concat(
            of(new auth.LoadUserNotificationsFailedAction(error)),
            of(null).pipe(
              tap(() => {
                const errorMessage = (error?.error != null && error.error.message != null)
                  ? error.error.message
                  : error.message;
                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  /**
   * Upload User Profile Image
   */
  public updateUserImage$ = createEffect(() => this.actions$.pipe(
    ofType<auth.UpdateUserProfileImageAction>(auth.ActionTypes.UPDATE_USER_PROFILE_IMAGE),
    map(action => action.payload),
    switchMap(payload => this.updateUserProfileImage(payload).pipe(
      map((response: any) =>
        new auth.UpdateUserProfileImageSuccessAction(response.profileImageId)
      ),
      catchError(error =>
        //   from([
        //   new AddErrorToastAction(!isNullOrUndefined(error.error)
        //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message),
        //   new auth.UpdateUserProfileImageFailedAction(error)
        // ])
        // {
        //   this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
        //   return of(new auth.UpdateUserProfileImageFailedAction(error));
        // }
        concat(
          of(new auth.UpdateUserProfileImageFailedAction(error)),
          of(null).pipe(
            tap(() => {
              const errorMessage = (error?.error != null && error.error.message != null)
                ? error.error.message
                : error.message;
              this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
            })
          )
        )
      )
    ))
  ));


  /**
   * Mark as read Notification by User
   */
  public markNotificationAsRead$ = createEffect(() => this.actions$.pipe(
    ofType<auth.MarkUserNotificationAction>(auth.ActionTypes.MARK_USER_NOTIFICATION),
    map(action => action.payload),
    switchMap((payload) =>
      this.markNotificationAsRead(payload).pipe(
        map((response: LoadNotificationResponse) =>
          new auth.MarkUserNotificationSuccessAction(response)
        ),
        catchError(error =>
          //   from([
          //   new AddErrorToastAction(!isNullOrUndefined(error.error)
          //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message),
          //   new auth.MarkUserNotificationFailedAction(error)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
          //   return of(new auth.MarkUserNotificationFailedAction(error));
          // }
          concat(
            of(new auth.MarkUserNotificationFailedAction(error)),
            of(null).pipe(
              tap(() => {
                const errorMessage = (error?.error != null && error.error.message != null)
                  ? error.error.message
                  : error.message;
                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  /**
   * Remove User Profile Image
   */
  public removeLogedUserProfileImage$ = createEffect(() => this.actions$.pipe(
    ofType<auth.RemoveLogedUserProfileImageAction>(auth.ActionTypes.REMOVE_LOGED_USER_PROFILE_IMAGE),
    map(action => action.payload),
    switchMap(payload => {
      if (!isNullOrUndefined(payload) && !isNullOrUndefined(payload.imageId) && !isNullOrUndefined(payload.imageType)) {

        return this.removeLogedUserProfileImage(payload).pipe(
          switchMap(() =>
            [
              // new AddSuccessToastAction('Success Message'),
              new auth.RemoveLogedUserProfileImageSuccessAction()
            ]
          ),
          catchError(error =>
            //   from([
            //   new AddErrorToastAction(!isNullOrUndefined(error.error)
            //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message),
            //   new auth.RemoveLogedUserProfileImageFailedAction(error)
            // ])
            // {
            //   this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
            //   return of(new auth.RemoveLogedUserProfileImageFailedAction(error));
            // }
            concat(
              of(new auth.RemoveLogedUserProfileImageFailedAction(error)),
              of(null).pipe(
                tap(() => {
                  const errorMessage = (error?.error != null && error.error.message != null)
                    ? error.error.message
                    : error.message;
                  this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                })
              )
            )
          )
        );
      }
    })
  ));

  /**
   * Forgot Password
   */
  public forgotPassword$ = createEffect(() => this.actions$.pipe(
    ofType<auth.ForgotPasswordAction>(auth.ActionTypes.FORGOT_PASSWORD),
    map(action => action.payload),
    switchMap(payload => {
      if (!isNullOrUndefined(payload) && !isNullOrUndefined(payload.email)) {
        return this.forgotPassword(payload).pipe(
          map((response) =>
            new auth.ForgotPasswordSuccessAction(response)
          ),
          catchError(error =>
            //   from([
            //   new AddErrorToastAction(!isNullOrUndefined(error.error)
            //     && !isNullOrUndefined(error.error.message) ? error.error.message : error.message),
            //   new auth.ForgotPasswordFailedAction(error)
            // ])
            // {
            //   this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
            //   return of(new auth.ForgotPasswordFailedAction(error));
            // }
            concat(
              of(new auth.ForgotPasswordFailedAction(error)),
              of(null).pipe(
                tap(() => {
                  const errorMessage = (error?.error != null && error.error.message != null)
                    ? error.error.message
                    : error.message;
                  this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                })
              )
            )
          )
        );
      }
    })
  ));

  public constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly _authService: AuthService,
    private readonly _toasterService: ToastService
  ) {
  }

  private getUser(): Observable<User> {
    return this.http.get<User>(`${CONFIG.API_URL}/users/me`, { withCredentials: true });
  }

  private logOut(): Observable<User> {
    return this.http.get<User>(`${CONFIG.API_URL}/users/logout`, { withCredentials: true });
  }

  private refreshToken(): Observable<LoginResponse> {
    return this.http.get<LoginResponse>(`${CONFIG.API_URL}/users/token`, { withCredentials: true });
  }

  private acceptTerms(): Observable<EmptyResponse> {
    return this.http.put<EmptyResponse>(`${CONFIG.API_URL}/users/terms`, {}, { withCredentials: true });
  }

  private loadUserNotification(): Observable<LoadNotificationResponse> {
    return this.http.get<LoadNotificationResponse>(`${CONFIG.API_URL}/admin/notifications`, { withCredentials: true });
  }
  private markNotificationAsRead(payload): Observable<LoadNotificationResponse> {
    return this.http.put<LoadNotificationResponse>(`${CONFIG.API_URL}/admin/notifications`, { _id: payload }, { withCredentials: true });
  }
  public updateUserProfileImage(payload: any): Observable<any> {
    return this.http.put(`${CONFIG.API_URL}/users/setProfileImage/${payload.get('_id')}/${payload.get('profileImageId')}`,
      payload, { withCredentials: true });
  }
  private removeLogedUserProfileImage(payload): Observable<any> {
    if (!isNullOrUndefined(payload.imageId) && !isNullOrUndefined(payload.imageType)) {
      return this.http.put(`${CONFIG.API_URL}/admin/image/${payload.imageId}/${payload.imageType}`, { withCredentials: true });
    }
  }

  private forgotPassword(payload): Observable<any> {
    return this.http.post(`${CONFIG.API_URL}/users/forgotPassword/`, payload, { withCredentials: false });
  }

  private mergeUserClaimsFromToken(user: User): User {
    if (!user) {
      return user;
    }

    const token = localStorage.getItem('auth_token');
    const claims = this.getUserClaimsFromToken(token);

    return {
      ...user,
      role: claims.role || user.role,
      type: claims.type || user.type
    };
  }

  private getUserClaimsFromToken(token?: string): { role?: string; type?: string } {
    if (!token) {
      return {};
    }

    try {
      const payload = JSON.parse(atob(token.replace(/^Bearer\s+/, '').split('.')[1]));
      return { role: payload?.role, type: payload?.type };
    } catch {
      return {};
    }
  }

  private initializePendo(user) {
    if (!isNullOrUndefined(user)) {
      const isStage = (`${CONFIG.API_URL.includes('stage')}` && environment.APP_ENV === 'production') ? true : false,
        isProd = (environment.APP_ENV === 'production') ? true : false,
        isQA = (environment.APP_ENV === 'QA') ? true : false,
        isLocal = (environment.APP_ENV === 'development') ? true : false,
        map = isLocal ? 'LA' : (isQA ? 'AQ' : (isStage ? 'ES' : (isProd ? 'DP' : 'NA')));

      pendo.initialize({
        visitor: {
          id: `${user._id}${map}`,
          type: `${map}`,
          act: !isNullOrUndefined(user.role) ? `${user.role.slice(0, 2)}${user.role.slice(-2)}` : 'NA',
          map: !isNullOrUndefined(user.org) ? user.org.country.slice(0, 1).toUpperCase() : 'NA',
          client: !isNullOrUndefined(user.org) ? user.org.name.split(' ')
            .map((subName) => subName.substring(0, 2)).join('').toUpperCase() : 'NA'
        }
      });
    }
  }
}
